module.exports = __webpack_public_path__ + "img/m5-5.11f776ac.png";